import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { ErrorBoundary } from './ErrorBoundary';

/** Keep the authenticated shell/feed alive while isolating a failed view. */
export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const userId = useAuthStore((s) => s.user?.id ?? null);
  return <ErrorBoundary resetKey={JSON.stringify([userId, pathname])}>{children}</ErrorBoundary>;
}
